import {createGetHook} from "services/http/hooks";
import {Currency} from "../../../types/global";
// Static GET: Currencies
export const useGetCurrenciesQuery = createGetHook<Currency[]>("/currencies");
